module.exports = __webpack_public_path__ + "static/media/13.e3c2481b.JPG";